export const WEEK_SELECTOR_MAX_WEEKS_COUNT = 52;
